import { getUnixTime } from "date-fns";
import { PRODUCT_FEATURE_STATUSES } from "../../consts";
import { ProductFeature, ProductFeatureType } from "../../types";

export const getProductFeature = (
  productFeatures: ProductFeature[] | undefined = [],
  feature: ProductFeatureType,
): ProductFeature | null => {
  return (
    productFeatures?.find?.(
      (productFeature) => feature === productFeature.feature,
    ) ?? null
  );
};

export const getProductFeatureActive = (
  productFeatures: ProductFeature[] | undefined = [],
  feature: ProductFeatureType,
): boolean => {
  const productFeature = getProductFeature(productFeatures, feature);

  if (!productFeature) return false;

  if (productFeature.status === PRODUCT_FEATURE_STATUSES.TRIAL) {
    if (!productFeature.start_date || !productFeature.expiration_date) {
      return false;
    }

    return (
      productFeature.start_date <= getUnixTime(new Date()) &&
      productFeature.expiration_date > getUnixTime(new Date())
    );
  }

  return productFeature.status === PRODUCT_FEATURE_STATUSES.ACTIVE;
};
